import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Stack, Typography, Link, Grid } from "@mui/material";
import { INK, BeltStripe } from "../theme/brand";

const LEGAL_LINKS = [
  ["Impressum", "/impressum"],
  ["Datenschutz", "/datenschutz"],
  ["AGB", "/agb"],
];

export default function SiteFooter() {
  return (
    <Box component="footer" sx={{ bgcolor: INK, color: "#fff" }}>
      <BeltStripe height={4} />
      <Container
        maxWidth="lg"
        sx={{ pt: 6, pb: "calc(40px + env(safe-area-inset-bottom))" }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src="/assets/logos/martialverselogodark.png"
              alt="MartialVerse"
              sx={{ height: 28, mb: 2 }}
            />
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.55)", maxWidth: 320 }}
            >
              Verwaltungssoftware für Kampfsportschulen – Mitglieder,
              Beiträge, Gürtelprüfungen und Rechnungen an einem Ort.
            </Typography>
          </Grid>

          <Grid item xs={6} md={3.5}>
            <Typography
              variant="overline"
              sx={{ color: "rgba(255,255,255,0.4)", fontWeight: 700 }}
            >
              Website
            </Typography>
            <Stack spacing={1} sx={{ mt: 1.5 }}>
              <Link
                href="/#funktionen"
                underline="hover"
                sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
              >
                Funktionen
              </Link>
              <Link
                href="/#neu"
                underline="hover"
                sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
              >
                Neu: Digitale Abbuchung
              </Link>
              <Link
                href="/#preise"
                underline="hover"
                sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
              >
                Preise
              </Link>
              <Link
                component={RouterLink}
                to="/mitgliederverwaltung"
                underline="hover"
                sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
              >
                Mitgliederverwaltung
              </Link>
              <Link
                component={RouterLink}
                to="/digitale-beitragsabbuchung"
                underline="hover"
                sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
              >
                Digitale Beitragsabbuchung
              </Link>
              <Link
                component={RouterLink}
                to="/guertelpruefungen"
                underline="hover"
                sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
              >
                Gürtelprüfungen
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={6} md={3.5}>
            <Typography
              variant="overline"
              sx={{ color: "rgba(255,255,255,0.4)", fontWeight: 700 }}
            >
              Rechtliches
            </Typography>
            <Stack spacing={1} sx={{ mt: 1.5 }}>
              {LEGAL_LINKS.map(([label, to]) => (
                <Link
                  key={to}
                  component={RouterLink}
                  to={to}
                  underline="hover"
                  sx={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}
                >
                  {label}
                </Link>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
          sx={{
            mt: 5,
            pt: 3,
            borderTop: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.5)" }}>
            © {new Date().getFullYear()} Softabit – MartialVerse
          </Typography>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.35)" }}>
            Angelos Galios · Karwendelstraße 126 · 86163 Augsburg
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
